// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateIsSaved = data => ({
    data,
    type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
});



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/update-is-saved.js